export enum PRISMIC_ZONE_LAYOUT {
    DEFAULT = 'Default',
    SPOTLIGHT = 'Spotlight',
    ONE_ROW = '1 Row',
    TWO_ROW = '2 Row',
    TALL = 'Tall',
    VERTICAL_FEATURED_GRID = 'Vertical Featured Grid'
}

export const COLLECTION_ZONE_LAYOUT = {
    [PRISMIC_ZONE_LAYOUT.DEFAULT]: 'default',
    [PRISMIC_ZONE_LAYOUT.SPOTLIGHT]: 'spotlight',
    [PRISMIC_ZONE_LAYOUT.ONE_ROW]: 'one_row',
    [PRISMIC_ZONE_LAYOUT.TWO_ROW]: 'two_row',
    [PRISMIC_ZONE_LAYOUT.TALL]: 'tall',
    [PRISMIC_ZONE_LAYOUT.VERTICAL_FEATURED_GRID]: 'vertical_featured_grid'
};

export const ZONE_SLICE_TYPES = {
    CAROUSEL: 'carousel',
    COLLECTION: 'collection',
    GRID_COLLECTION: 'grid_collection',
    RECENTLY_PLAYED_GAMES: 'recently_played_games',
    JACKPOT_ZONE_ENTRY_POINT: 'jackpot_zone_entry_point',
    TRENDING_GAMES_CONFIGURATION: 'trending_games_configuration',
    ANIMATED_TRAILER: 'animated_trailer',
    EXCLUSIVE_POST_LAUNCH: 'post_launch',
    EXCLUSIVE_PRE_LAUNCH: 'pre_launch',
    TOP_PICKS_FOR_YOU: 'games_recommender_configuration',
    RICH_TEXT_ZONE: 'rich_text',
    BECAUSE_YOU_PLAYED: 'because_you_played',
    CATEGORY_GAMES_PLACEHOLDER: 'category_games_placeholder',
    SITE_WIDE_JACKPOT: 'jackpot',
    INCENTIVE_GAMES_ENTRY_POINT_ZONE: 'incentive_games_entry_point_zone',
    COLLECTIONS_ENTRY_SHOWCASE: 'collections_entry_showcase',
    FAVOURITE_GAMES: 'favourite_games',
    CATEGORY_HEADER: 'category_header',
    USER_ONBOARDING: 'user_onboarding',
    SKINNY_BANNER: 'skinny_banner',
    INFLUENCER_PAGE_ENTRY_POINT: 'influencer_page_entry_point',
    SIMILAR_GAMES: 'similar_games',
    CASINO_DYNAMIC_ZONE: 'casino_dynamic_zone',
    HOT_RIGHT_NOW: 'hot_right_now'
} as const;

export type ZoneSliceType = (typeof ZONE_SLICE_TYPES)[keyof typeof ZONE_SLICE_TYPES];

export const RECENTLY_PLAYED_BANNER_ID = 'recently_played' as const;
